import React from 'react'
import Navbar from '../components/navbar'
import bg1 from '../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import ShapeTwo from '../components/shape-two'
import PricingTwo from '../components/pricing-two'
import PricingOne from '../components/pricing-one'
import About from '../components/about'
import Shape from '../components/shape'
import Footer from '../components/footer'

export default function PagePricing() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Pricing</h4>
                            <p className="text-muted mb-0">Our comfirtable rates or price</p>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                            <li className="list-inline-item"><span className="text-uppercase text-primary fw-bold">Pricing</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Layout #1</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web
                          with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <PricingOne/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Layout #2</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web
                          with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <PricingTwo/>
      </div>

      <div className="container mt-100 mt-60">
          <About/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <span className="badge bg-primary rounded-pill"> Subscribe </span>
                      <h4 className="title mt-3 mb-4">Sign up for our Newsletter</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web
                          with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-lg-9 mt-4 pt-2">
                  <form>
                      <div className="row justify-content-center align-items-center">
                          <div className="col-md-4">
                              <div className="mb-3">
                                  <label className="form-label">First Name <span className="text-danger">*</span></label>
                                  <input name="name" id="fname" type="text" className="form-control"
                                      placeholder="First Name :"/>
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="mb-3">
                                  <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                  <input name="name" id="lname" type="text" className="form-control"
                                      placeholder="Last Name :"/>
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="mb-3">
                                  <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                  <input name="email" id="email" type="email" className="form-control"
                                      placeholder="Your email :"/>
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="d-grid">
                                  <button id="subscribe" type="submit" className="btn btn-primary mb-2">Subscribe</button>
                              </div>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
    </section>
    
    <Shape/>
    <Footer/>
    </>
  )
}
